import { render } from "./ElemProject.vue?vue&type=template&id=afe4ccbe&scoped=true"
import script from "./ElemProject.vue?vue&type=script&lang=js"
export * from "./ElemProject.vue?vue&type=script&lang=js"

import "./ElemProject.vue?vue&type=style&index=0&id=afe4ccbe&lang=scss&scoped=true"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe4ccbe"]])

export default __exports__